export default __webpack_public_path__ + "static/media/app-store-badge.fe372262.png";